
// @ts-nocheck
import { mapGetters } from 'vuex'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Id } from '@/components/ibx/base/Types'
import { PieAuthorPassageService } from '@/services/pie'
import { fixLegacyPassageMarkup } from '@/helpers/passageMarkup'
import { buildPieConfig } from '@/helpers/pieConfig'
import _ from 'lodash'

@Component({
  computed: {
    ...mapGetters('auth', {
      authPieToken: 'pieToken',
    }),
  },
})
export default class PiePassageAuthor extends Vue {
  @Prop({ default: null }) remoteId: Id

  private piePassageService: PieAuthorPassageService = null

  get passageConfigSettings(): any {
    return {
      title: { label: 'Title', required: true },
      subtitle: { label: 'Subtitle', required: false },
      author: { label: 'Author', required: false },
      text: { label: 'Text', required: true },
      teacherInstructions: { label: 'Teacher Instructions', required: false },
    }
  }

  get defaultPassageContentConfig(): any {
    return buildPieConfig({})
  }

  /**
   * Must stay a method, not a getter: $refs.player.contentConfig is a plain
   * property on a native custom element, not Vue-reactive, so a cached
   * computed would freeze on its first-read value and every later save
   * would silently write that stale, initial config.
   */
  getContentConfig(): any {
    return _.cloneDeep(this.$refs?.player?.contentConfig) || this.defaultPassageContentConfig
  }

  async savePassage(config?: any): Promise<any> {
    return await this.piePassageService.savePassage({
      versionedID: '',
      config: config || this.getContentConfig(),
      release: true,
    })
  }

  async loadContentConfig(): Promise<any> {
    if (!this.remoteId) return this.defaultPassageContentConfig

    try {
      const { data } = await this.piePassageService.getPassage({ versionedID: this.remoteId })
      return fixLegacyPassageMarkup(data?.config) || this.defaultPassageContentConfig
    } catch (error) {
      console.warn(error)
      this.$emit('load-error', error)
      return this.defaultPassageContentConfig
    }
  }

  created() {
    this.piePassageService = new PieAuthorPassageService({
      token: this.authPieToken,
      apiUrl: process.env.VUE_APP_PIE_URI,
    })
  }

  /**
   * Mirrors ItemAuthorPlayer.vue's initPlayer() pattern.
   */
  async mounted() {
    const player: any = this.$refs.player
    if (!player) return

    player.token = this.authPieToken
    player.host = `${process.env.VUE_APP_PIE_PLAYER_ENV}`
    player.lockVersions = false
    player.configSettings = this.passageConfigSettings
    player.contentConfig = await this.loadContentConfig()

    player.addEventListener('modelUpdated', () => this.$emit('change'))
  }
}
